var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg7ZDocument = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.22894 0.5H14.2289C14.6268 0.5 15.0083 0.658035 15.2896 0.93934C15.5709 1.22064 15.7289 1.60218 15.7289 2V14C15.7289 14.3978 15.5709 14.7794 15.2896 15.0607C15.0083 15.342 14.6268 15.5 14.2289 15.5H2.22894C1.83112 15.5 1.44959 15.342 1.16828 15.0607C0.886978 14.7794 0.728943 14.3978 0.728943 14V2C0.728943 1.60218 0.886978 1.22064 1.16828 0.93934C1.44959 0.658035 1.83112 0.5 2.22894 0.5Z",
  fill: "white",
  stroke: "#33343D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3182 6.98437L10.2864 9.53181C10.2088 9.62906 10.1666 9.74976 10.1666 9.87415C10.1666 10.1774 10.4124 10.4232 10.7156 10.4232H13.3326C13.6045 10.4232 13.8249 10.2027 13.8249 9.93084C13.8249 9.65893 13.6045 9.43851 13.3326 9.43851H11.7046L13.6326 6.9428C13.7104 6.84212 13.7526 6.71849 13.7526 6.59127V6.57471C13.7526 6.25714 13.4952 5.99971 13.1776 5.99971H10.7312C10.4593 5.99971 10.2389 6.22013 10.2389 6.49204C10.2389 6.76394 10.4593 6.98437 10.7312 6.98437H12.3182Z",
  fill: "#33343D",
  stroke: "#33343D",
  strokeWidth: 0.15
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2.0827,
  y: 1.88428,
  width: 6.96127,
  height: 12.1874,
  rx: 1,
  fill: "#33343D"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.627 5.48088L3.80111 11.0743C3.60788 11.4567 3.88583 11.9085 4.31433 11.9085H4.61708C4.83444 11.9085 5.03323 11.786 5.13084 11.5918L8.15667 5.5714C8.19694 5.49128 8.21791 5.40285 8.21791 5.31318V4.7594C8.21791 4.44184 7.96047 4.1844 7.64291 4.1844H3.48376C3.1662 4.1844 2.90876 4.44184 2.90876 4.7594V4.90588C2.90876 5.22344 3.1662 5.48088 3.48376 5.48088H6.627Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.15,
  strokeLinejoin: "bevel"
})));
const ForwardRef = /*#__PURE__*/forwardRef(Svg7ZDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/7z-document.65d040c0e91de9aa305c020fb106e3f8.svg";